$(document).ready(function () {
    Inputmask({
        'mask': '+38 (999) 999-99-99',
        'clearMaskOnLostFocus': true,
        'clearIncomplete': true,
        'showMaskOnHover': false,
    }).mask('input[name="phone"]');

    $("#contact-form").validate({
        errorElement: 'span',
        errorClass: 'span__error',
        ignoreTitle: true,
        errorPlacement: function (error, element) {
            error.appendTo($(element).parents('.input-route-wrap'));
        },
        highlight: function (element) {
            $(element).parents('.input-route-wrap').addClass("forms__error");
        },
        unhighlight: function (element) {
            $(element).parents('.input-route-wrap').removeClass("forms__error");
        },
        submitHandler: function (form) {
            var csrf_token = $('meta[name="csrf-token"]').attr('content');
            var formdata = $("#form-reviews").serialize();
            $("#contact-form")[0].reset();
            $.ajax({
                url: routes.postSend,
                type: 'POST',
                data: {
                    "_token": csrf_token,
                    "data": formdata,
                    "subj": "feedback",
                },
                success: function (data) {
                    // console.log(data)
                    // $("#form_reviews_success").slideDown();
                    // $("#form_reviews_success").css({'display': 'block'})

                    // setTimeout(function () {
                    //     $("#form_reviews_success").slideUp(500)
                    // }, 2500)
                }
            })
        }
    });
    $('#contact-btn').click(function (e) {
        e.stopPropagation();
        e.preventDefault();
        $("#contact-form").submit();
    });


    $("#checkbox-btn").change(function () {
        if (this.checked) {
            $("#do_order_btn").removeClass('js_disabled');
            $('.js_label-two').addClass('js_hide');
            $('.js_label-one').removeClass('js_hide');
        } else {
            $("#do_order_btn").addClass('js_disabled');
        }
    });
    $("#order_form").validate({
        errorElement: 'span',
        errorClass: 'span__error',
        ignoreTitle: true,
        errorPlacement: function (error, element) {
            error.appendTo($(element).parents('.cart-input-wrap'));
        },
        highlight: function (element) {
            $(element).parents('.cart-input-wrap').addClass("forms__error");
        },
        unhighlight: function (element) {
            $(element).parents('.cart-input-wrap').removeClass("forms__error");
        },
        submitHandler: function (form) {
            var csrf_token = $('meta[name="csrf-token"]').attr('content');
            var formdata = $("#order_form").serialize();
            $("#order_form")[0].reset();
            $.ajax({
                url: routes.doOrder,
                type: 'POST',
                data: {
                    "_token": csrf_token,
                    "data": formdata,
                    "subj": "market_order",
                },
                success: function (data) {
                    // $("#feedback_success").slideDown();
                    // $("#feedback_seccess").css({'display': 'block'})
                    // setTimeout(function () {
                    //     $("#feedback_success").slideUp(500)
                    // }, 2500)
                    console.log(data)
                    window.location = "/success-purchase";
                }
            })
        }
    });
    $("#do_order_btn").click(function (e) {
        e.stopPropagation();
        e.preventDefault();
        // if(!$(this).hasClass('js_disabled')) {
        $("#order_form").submit();

        // $('.js_label-two').addClass('js_hide');
        // $('.js_label-one').removeClass('js_hide');
        // } else {
        // $('.js_label-one').addClass('js_hide');
        // $('.js_label-two').removeClass('js_hide');
        // }
    });

    $("#callback-form").validate({
        errorElement: "span",
        errorClass: "span__error",
        ignoreTitle: true,
        errorPlacement: function (error, element) {
            error.appendTo($(element).parents(".input_form_container"));
        },
        highlight: function (element) {
            $(element)
                .parents(".input_form_container")
                .addClass("forms__error");
        },
        unhighlight: function (element) {
            $(element)
                .parents(".input_form_container")
                .removeClass("forms__error");
        },
        submitHandler: function (form) {
            var csrf_token = $('meta[name="csrf-token"]').attr("content");
            var formdata = $("#callback-form").serialize();
            $("#callback-form")[0].reset();
            $.ajax({
                url: routes.postSend,
                type: "POST",
                data: {
                    _token: csrf_token,
                    data: formdata,
                    subj: "callback",
                },
                success: function (data) {
                    $("#callback_success").slideDown();
                    $("#callback_success").css({ display: "block" });
                    setTimeout(function () {
                        $(".modal-callback").removeClass("active");
                        $("#callback_success")
                            .css({ display: "none" })
                            .slideUp(2500);
                    }, 5000);
                    $('body').removeClass('lock-modal')
                },
            });
        },
    });
    $("#callback-btn").click(function (e) {
        e.stopPropagation();
        e.preventDefault();
        $("#callback-form").submit();
    });

    const form = function () {
        var Main = (function ($) {
            var labelText = $('.form__file-lt:lt(1)').text();
            $(function () {
                Main.init();
            })
            return {
                init: function () {
                    var self = this;
                    self.inputHadler();
                    self.valid();
                    self.formValidates();
                    self.fileInputs();
                },
                fileInputs: function () {
                    $('.js_add_file').click(function (e) {
                        e.preventDefault();
                        var nb
                        if ($('.js_item_file_reviews').length == 0) {
                            nb = $('.js_item_file_reviews').length + 1;
                        } else {
                            nb = + $('.js_item_file_reviews').attr('data-number') + 1;
                        }
                        if ($('.js_item_file_reviews').length < 2) {
                            console.log(nb);
                            var sizeError = document.querySelector('.form__size-error-js'),
                                extensionError = document.querySelector('.form__extention-err-js');
                            var whiteList = [
                                "text/plain",
                                "application/msword",
                                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                "application/vnd.oasis.opendocument.text",
                                "application/rtf",
                                "application/pdf",
                                "application/octet-stream",
                                "image/jpeg",
                                "image/png",
                                "application/vnd.ms-excel",
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                "application/vnd.oasis.opendocument.spreadsheet",
                            ];
                            var $input = $('<input type="file" value="" name="photo_' + nb + '" accept="image/*" class="input-hidden input-file-js"/>');
                            var form = e.target.closest('.form-reviews')
                            $input.on('change', function (evt) {
                                if (this.files.length) {
                                    for (var i = 0; i < this.files.length; i++) {
                                        if ((whiteList.indexOf(this.files[i].type) != -1 && this.files[i].size < 12000000) || ((this.files[i].name).indexOf('.dwg') != -1 && this.files[i].size < 12000000)) {
                                            sizeError.classList.remove('js_show');
                                            extensionError.classList.remove('js_show');
                                            var f = evt.target.files[0];
                                            console.log($(this))
                                            $(form).append($(this));
                                            $('ul.js_list_file_reviews').append('<li class="js_item_file_reviews item_file_reviews" data-number="' + nb + '" data-item="photo_' + nb + '"><span class="name">' + f.name + '</span><span class="js_item_file_delete item_file_delete"></span></li>');
                                            if ($('.js_item_file_reviews').length == 2) {
                                                document.querySelector('.js_add_file').classList.add('js_hide');
                                            }
                                        } else {
                                            sizeError.classList.remove('js_show');
                                            extensionError.classList.remove('js_show');
                                            if (whiteList.indexOf(this.files[i].type) == -1) extensionError.classList.add('js_show');
                                            if (this.files[i].size > 12000000) sizeError.classList.add('js_show');
                                            console.log(this.files[i].size);
                                            console.log(whiteList.indexOf(this.files[i].type));
                                            $(this).value = '';
                                            $(this).closest('.form__file-wr').find('.form__file-remove').addClass('js_hide');
                                        }
                                    }
                                }
                            });
                            $input.hide();
                            $input.trigger('click');
                        } else {
                            $(this).classList.add('js_hide');
                        }
                    });
                },
                valid: function (data) {
                    function sendTextFields(item, formdata, file = '') {
                        var dataForm;
                        console.log(file)
                        if (file != '') {
                            dataForm = {
                                data: formdata,
                                file: file,
                                subj: "review",
                            }
                        } else {
                            dataForm = {
                                data: formdata,
                                subj: "review",
                            };
                        };
                        $.ajax({
                            url: routes.postSend,
                            type: 'POST',
                            data: dataForm,
                            success: function (data) {
                                $(item)[0].reset();
                                if (document.querySelectorAll('.input-file-js') != null) {
                                    $('.js_add_file').removeClass('js_hide');
                                    $('.js_list_file_reviews').empty();
                                    $('.input-file-js').remove();
                                };
                                setTimeout(function () {
                                    $('.ajax-loader').addClass('hidden');
                                    $('#form-reviews').find(".form-input").val("").blur();
                                    $('.span__error').css('display', 'none');
                                    $(".review-form-js").find('.review-form__success').slideDown(300);
                                }, 100);
                                setTimeout(function () {
                                    $(".review-form-js").find('.review-form__success').slideUp(300);
                                }, 3000);
                            }
                        })
                    };
                    var item = data;
                    $(item).validate({
                        errorElement: 'span',
                        errorClass: 'span__error',
                        ignoreTitle: true,
                        errorPlacement: function (error, element) {
                            error.appendTo($(element).parents('.input-route-wrap'));
                        },
                        highlight: function (element) {
                            $(element).parents('.input-route-wrap').addClass("forms__error");
                        },
                        unhighlight: function (element) {
                            $(element).parents('.input-route-wrap').removeClass("forms__error");
                        },
                        submitHandler: function (form) {
                            var csrf_token = $('meta[name="csrf-token"]').attr('content');
                            var formdata = $(item).serialize();
                            console.log(document.querySelectorAll('.input-file-js'))
                            if (document.querySelectorAll('.input-file-js') != null && document.querySelectorAll('.input-file-js').length != 0) {
                                console.log(111)
                                var inputs = $('.input-file-js');
                                let $data = {};
                                for (let i = 0; i < inputs.length; i++) {
                                    let element = inputs[i];
                                    let next_el = (inputs[i + 1]) ? (inputs[i + 1]) : null;
                                    if (element != null && element.files.length) {
                                        let reader = new FileReader();
                                        reader.onload = function () {
                                            let key = 'file_' + i;
                                            let value = reader.result;
                                            $data[key] = value;
                                            if (next_el == null || !next_el.files.length) {
                                                setTimeout(function () {
                                                    $.ajax({
                                                        type: 'POST',
                                                        url: routes.postLoadFile,
                                                        data: {
                                                            "_token": csrf_token,
                                                            "data": $data,
                                                        },
                                                        success: function (response) {
                                                            var uploadedFile = response.file_name;

                                                            sendTextFields(item, formdata, uploadedFile);
                                                        },
                                                        error: function (response) { },
                                                    });
                                                }, 100);
                                            }
                                        };
                                        reader.readAsDataURL(inputs[i].files[0]);
                                    }
                                }
                            } else {
                                sendTextFields(item, formdata);
                                console.log(222)
                            }
                        }
                    });
                },
                formValidates: function () {
                    var button = document.getElementById('reviews-btn'),
                        form = document.getElementsByClassName('review-form-js');
                    function submitForm(event) {
                        event.preventDefault();
                        event.stopPropagation();

                        Main.valid(form);
                        $(form).submit();

                        return form;
                    }
                    if (button != null) {
                        button.addEventListener('click', submitForm, true);
                    }


                },
                inputHadler: function () {
                    $(document).on('click', '.js_item_file_delete', function (e) {
                        var item_file = $(this).parent('.js_item_file_reviews').attr('data-item');
                        $(this).parent('.js_item_file_reviews').remove();
                        $('.input-file-js[name=' + item_file + ']').remove();
                        if ($('.js_item_file_reviews').length < 2) {
                            $('.js_add_file').removeClass('js_hide');
                        }
                    });
                }
            }
        })(jQuery);

    }

    form();

    let formReviews = $('.goods-page-form-reviews').html();
    if (formReviews) {
        formReviews = formReviews.innerHTML = `<div class="goods-page-form-reviews" id="leads">${formReviews}</div>`;
    }

    $('.main-tab-btn').click(function (e) {
        e.preventDefault();

        $('.goods-page-form-reviews').remove();

        if (e.currentTarget.getAttribute("data-alias") == 'goods-reviews') {
            $('.reviews-form-block').append(formReviews);
        } else {
            $('.goods-page-bottom .goods-bottom-flex').after(formReviews)
        }

        form();

        let alias = $(this).attr("data-alias");
        $(".main-tab-btn").removeClass("active");
        $(this).addClass("active");
        $(".good-page").removeClass("active");
        $('.good-page[data-alias="' + alias + '"]').addClass("active");
    });

    function reloadTopCart() {
        $.post(routes.reloadTopCart, {}, function (data) {
            if (data.status == "ok") {
                $(".market-number").empty().append(data.count);
                let myCount = document.querySelector(".count-js");
                if (myCount.innerHTML >= 1) {
                    myCount.classList.add("active");
                    $('.market-link').css('pointer-events', 'auto')
                }
            }
        });
    }

    var lang = $("html").attr("lang");
    var ajax_url;
    $(document).on("click", ".good-btn_js", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var good_id = $(this).attr("data-id");
        $(".modal-goods").empty();
        $.ajax({
            type: "POST",
            url: routes.reloadGoodOrder,
            data: {
                good_id: good_id,
                lang: lang,
            },
            success: function (data) {
                $(".modal-goods").empty().append(data.html);
                reloadTopCart();
                $(".modal-goods").addClass("open");

                !function (f, b, e, v, n, t, s) {
                    if (f.fbq) return; n = f.fbq = function () {
                        n.callMethod ?
                        n.callMethod.apply(n, arguments) : n.queue.push(arguments)
                    };
                    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
                    n.queue = []; t = b.createElement(e); t.async = !0;
                    t.src = v; s = b.getElementsByTagName(e)[0];
                    s.parentNode.insertBefore(t, s)
                }(window, document, 'script',
                    'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', '220634783227308');
                fbq('track', 'PageView');
                fbq('track', 'AddToCart');
            },
        });
    });

    let modalGoods = document.querySelector('.modal-goods')
    let modalGoodsDialog = document.querySelector('.modal-goods-dialog')
    modalGoods.addEventListener("click", function (e) {
        if (modalGoods == e.target) {
            modalGoods.classList.remove("open");
        }
    });
    let myHeader = document.querySelector('.header')
    let mainWrap = document.querySelector('.main-wrap')
    let myHeaderHeight = myHeader.offsetHeight
    let langlist = document.querySelector('.langlist')
    let headerBottom = document.querySelector('.bottom-header')
    let searchBlock = document.querySelector('.header-bottom-right')
    if (window.innerWidth < 1024) {
        myHeader.appendChild(searchBlock)
        headerBottom.insertBefore(langlist, headerBottom.firstChild)
    }
    mainWrap.style.paddingTop = myHeaderHeight + 'px'


    let myCount = document.querySelector('.count-js')
    if (myCount.innerHTML >= 1) {
        myCount.classList.add('active');
    }

    let headerSearch = document.querySelector('.header-search')
    let searchForm = document.querySelector('.search-js')
    let searchClose = document.querySelector('.close-search')
    let myBurger = document.querySelector('.burger')
    let searchInput = document.querySelector('.top-input-search')
    headerSearch.addEventListener('click', function (e) {
        if (headerSearch) {
            searchForm.classList.toggle('open')
            headerSearch.classList.toggle('open')
            searchClose.classList.toggle('open')
            myBurger.classList.toggle('none')
            searchInput.focus();
        }
    })
    searchClose.addEventListener('click', function (e) {
        if (searchClose) {
            searchClose.classList.toggle('open')
            searchForm.classList.toggle('open')
            headerSearch.classList.toggle('open')
            myBurger.classList.toggle('none')
        }
    })

    let burger = document.querySelector('.burger')
    let myBody = document.body;
    let header = document.querySelector('.header')
    burger.addEventListener('click', function (e) {
        if (burger) {
            let bottomHeader = document.querySelector('.bottom-header')
            bottomHeader.classList.toggle('active')
            burger.classList.toggle('active')
            myBody.classList.toggle("blur")
            header.classList.toggle('header-height')
        }
    })

    let accordeonFooterBtn = document.querySelectorAll('.footer-menu-name')
    let accordeonFooterContent = document.querySelectorAll('.footer-menu-content')
    for (let i = 0; i < accordeonFooterBtn.length; i++) {
        accordeonFooterBtn[i].addEventListener('click', function (e) {
            if (accordeonFooterBtn[i]) {
                accordeonFooterBtn[i].classList.toggle('active')
                accordeonFooterContent[i].classList.toggle('active')

            }
        })
    }

    let headerBtnMore = document.querySelector('.btn-more')
    let headerMoreContent = document.querySelector('.header-left-drop-content')
    if (headerBtnMore != null) {

        headerBtnMore.addEventListener('click', function (e) {
            if (headerBtnMore) {
                e.preventDefault()
                headerMoreContent.classList.toggle('active')
                headerBtnMore.classList.toggle('active')
            }
        })
    }

    let headerPhoneContent = document.querySelector('.header-link-content')
    let headerPhoneBtn = document.querySelector('.header-link-drop')
    headerPhoneBtn.addEventListener('click', function (e) {
        if (headerPhoneBtn) {
            e.preventDefault()
            headerPhoneContent.classList.toggle('active')
            headerPhoneBtn.classList.toggle('active')
        }
    })

    let goodTileItem = document.querySelectorAll('.js__good_tile')
    if (goodTileItem.length == 0) {
        $('.search-none').css('display', 'flex');
        $('.top_navigate').css('display', 'none');
        $('.goods-list-blockgoods-list-block').css('display', 'none');
        $('.sorting-top-block').css('display', 'none');
    } else {
        $('.sorting-top-block').css('display', 'flex');
        $('.top_navigate').css('display', 'block');
        $('.goods-list-blockgoods-list-block').css('display', 'block');
        $('.search-none').css('display', 'none');
    }
})

